import React, { useEffect, useState } from "react";
import Accordeon from "../../Accordeon/index";
import { DietitianAccordeonProps } from "../../interface/interface";
import * as styles from "./styles.module.css";

const DietitianAccordeon: React.FC<DietitianAccordeonProps> = ({
  xponent,
  home,
  future,
}) => {
  const [openAccordeon, setOpenAccordeon] = useState<number>(0);
  const [accordeonSize, setAccordeonSize] = useState<number>(0);

  useEffect(() => {
    home && setAccordeonSize(1);
    (xponent || future) && setAccordeonSize(2);
  }, []);

  return (
    <div
      className={`${home ? styles.accordeoncontainer : ""} ${
        xponent ? styles.xponentaccordeoncontainer : ""
      } ${future ? styles.futureaccordeoncontainer : ""}`}
    >
      <Accordeon
        accordeonSize={accordeonSize}
        open={openAccordeon === 0}
        setOpenAccordeon={setOpenAccordeon}
        order={0}
        buttontext="Set Personal Goals"
        text="Establish lifestyle changes that can help you reach your goals, by better understanding your own nutrition habits and performance routine."
      />
      <Accordeon
        accordeonSize={accordeonSize}
        open={openAccordeon === 1}
        setOpenAccordeon={setOpenAccordeon}
        order={1}
        buttontext="Progress, Evolve + Level Up"
        text="Looking to kick your regimen up a notch? Your Registered Dietitian will get you there with an actionable plan that supports your goals—and can be adjusted as needed."
      />
      <Accordeon
        accordeonSize={accordeonSize}
        open={openAccordeon === 2}
        setOpenAccordeon={setOpenAccordeon}
        order={2}
        buttontext="Always-On Guidance"
        text="Our Registered Dietitians are real people with real advice, and they’re on call to help you at every step of your journey."
      />
    </div>
  );
};

export default DietitianAccordeon;
